import React, { Component } from 'react';
import { Col, Form, Row }  from 'react-bootstrap';
import { connect } from 'react-redux';
import { updateAssetTypeSummary } from '../actions/assets'
import { updateLiabilityTypeSummary } from '../actions/liabilities'
import { initCurrencyInfo, setAggregationCurrency } from '../actions/currencies'
import { initNetWorthSummary } from '../actions/networth'
import Tier from '../constants/tiers';

// ISO 4217 fiat currency codes — kept in sync with backend tier_utils.py FIAT_CODES
const FIAT_CODES = new Set([
  'AED','AFN','ALL','AMD','ANG','AOA','ARS','AUD','AWG','AZN',
  'BAM','BBD','BDT','BGN','BHD','BIF','BMD','BND','BOB','BOV',
  'BRL','BSD','BTN','BWP','BYN','BZD','CAD','CDF','CHE','CHF',
  'CHW','CLF','CLP','CNY','COP','COU','CRC','CUC','CUP','CVE',
  'CZK','DJF','DKK','DOP','DZD','EGP','ERN','ETB','EUR','FJD',
  'FKP','GBP','GEL','GHS','GIP','GMD','GNF','GTQ','GYD','HKD',
  'HNL','HRK','HTG','HUF','IDR','ILS','INR','IQD','IRR','ISK',
  'JMD','JOD','JPY','KES','KGS','KHR','KMF','KPW','KRW','KWD',
  'KYD','KZT','LAK','LBP','LKR','LRD','LSL','LYD','MAD','MDL',
  'MGA','MKD','MMK','MNT','MOP','MRU','MUR','MVR','MWK','MXN',
  'MXV','MYR','MZN','NAD','NGN','NIO','NOK','NPR','NZD','OMR',
  'PAB','PEN','PGK','PHP','PKR','PLN','PYG','QAR','RON','RSD',
  'RUB','RWF','SAR','SBD','SCR','SDG','SEK','SGD','SHP','SLL',
  'SOS','SRD','SSP','STN','SVC','SYP','SZL','THB','TJS','TMT',
  'TND','TOP','TRY','TTD','TWD','TZS','UAH','UGX','USD','USN',
  'UYI','UYU','UYW','UZS','VES','VND','VUV','WST','XAF','XAG',
  'XAU','XBA','XBB','XBC','XBD','XCD','XDR','XOF','XPD','XPF',
  'XPT','XSU','XTS','XUA','XXX','YER','ZAR','ZMW','ZWL'
]);

function mapStateToProps (state) {
  return {
    assetSummary: state.assetInfo.assetSummary,
    liabilitySummary: state.liabilityInfo.liabilitySummary,
    currencyInfo: state.currencyInfo,
    userInfo: state.userInfo
  }
}

function mapDispatchToProps (dispatch) {
  return {
    initCurrencyInfo: aggregationCurrency => dispatch(initCurrencyInfo(aggregationCurrency)),
    setAggregationCurrency: aggregationCurrency => dispatch(setAggregationCurrency(aggregationCurrency)),
    updateAssetTypeSummary: (assetSummary, currencyInfo) => dispatch(updateAssetTypeSummary(assetSummary, currencyInfo)),
    updateLiabilityTypeSummary: (liabilitySummary, currencyInfo) => dispatch(updateLiabilityTypeSummary(liabilitySummary, currencyInfo)),
    initNetWorthSummary: (currencyInfo) => dispatch(initNetWorthSummary(currencyInfo))
  }
}

class AggregationCurrencySelector extends Component {
  constructor(props) {
    super(props);
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  async handleSelectChange(event) {
      event.preventDefault();
      await this.props.setAggregationCurrency(event.target.value);
      await Promise.all([
        this.props.updateAssetTypeSummary(this.props.assetSummary, this.props.currencyInfo),
        this.props.updateLiabilityTypeSummary(this.props.liabilitySummary, this.props.currencyInfo),
        this.props.initNetWorthSummary(this.props.currencyInfo)
      ])
  }

  async componentDidMount() {
    await this.props.initCurrencyInfo(this.props.currencyInfo.aggregationCurrency)
  }

  render() {
    const isFree = this.props.userInfo && this.props.userInfo.tier === Tier.FREE;
    const availableCurrencies = Object.keys(this.props.currencyInfo.currencyRates).filter(
      code => !isFree || FIAT_CODES.has(code)
    );
    return (
      <Form>
        <Form.Group as={Row} controlId="currencyList">
          <Col></Col>
          <Form.Label column>Aggregation Currency</Form.Label>
          <Col>
            <Form.Select name="aggregationCurrency" value={this.props.currencyInfo.aggregationCurrency} onChange={this.handleSelectChange}>
              {availableCurrencies.map(currency => <option key={currency}>{currency}</option>)}
            </Form.Select>
          </Col>
        </Form.Group>
      </Form>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AggregationCurrencySelector);
